// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { OAuthProvider } from "firebase/auth";

import {
  getAuth,
  signInWithPopup,
  signInWithRedirect,
  GoogleAuthProvider,
  getRedirectResult,
  sendSignInLinkToEmail,
  isSignInWithEmailLink,
  signInWithEmailLink,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { serverUrl } from "../constants";

const firebaseConfig = {
  apiKey: "AIzaSyBT4DD_Xl7QE_AQRpFzJIEvjwSxHdUnxvE",
  authDomain: "app.myindyx.com",
  projectId: "indyx-d8837",
  storageBucket: "indyx-d8837.appspot.com",
  messagingSenderId: "430152442052",
  appId: "1:430152442052:web:3bb940424595a23a746991",
  measurementId: "G-ZH1MHWHBMB",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const logEv = (eventName: string, data: any) => {
  logEvent(analytics, eventName, data);
};

const googleAuthProvider = new GoogleAuthProvider();
const appleAuthProvider = new OAuthProvider("apple.com");

appleAuthProvider.addScope("email");
appleAuthProvider.addScope("name");

/*
googleAuthProvider.addScope(
  "https://www.googleapis.com/auth/contacts.readonly"
);
*/

export const auth = getAuth();
auth.languageCode = "us";

getRedirectResult(auth)
  .then((result) => {
    // This gives you a Google Access Token. You can use it to access Google APIs.
    if (!result) {
      return;
    }
    const credential = GoogleAuthProvider.credentialFromResult(result);
    if (!credential) {
      return;
    }
    const token = credential.accessToken;

    // The signed-in user info.
    const user = result.user;
    // IdP data available using getAdditionalUserInfo(result)
    // ...
  })
  .catch((error) => {
    // Handle Errors here.
    const errorCode = error.code;
    const errorMessage = error.message;
    // The email of the user's account used.
    const email = error.customData.email;
    // The AuthCredential type that was used.
    const credential = GoogleAuthProvider.credentialFromError(error);
    // ...
  });

if (isSignInWithEmailLink(auth, window.location.href)) {
  // Additional state parameters can also be passed via URL.
  // This can be used to continue the user's intended action before triggering
  // the sign-in operation.
  // Get the email if available. This should be available if the user completes
  // the flow on the same device where they started it.
  let email = window.localStorage.getItem("emailForSignIn");
  if (!email) {
    // User opened the link on a different device. To prevent session fixation
    // attacks, ask the user to provide the associated email again. For example:
    email = window.prompt("Please provide your email for confirmation");
  }
  // The client SDK will parse the code from the link for you.
  signInWithEmailLink(auth, email || "", window.location.href)
    .then((result) => {
      // Clear email from storage.
      window.localStorage.removeItem("emailForSignIn");
      window.history.replaceState({}, document.title, window.location.pathname);
      // You can access the new user by importing getAdditionalUserInfo
      // and calling it with result:
      // getAdditionalUserInfo(result)
      // You can access the user's profile via:
      // getAdditionalUserInfo(result)?.profile
      // You can check if the user is new or existing:
      // getAdditionalUserInfo(result)?.isNewUser
    })
    .catch((error) => {
      console.error(error);
      // Some error occurred, you can inspect the code: error.code
      // Common errors could be invalid email and invalid or expired OTPs.
    });
}

export const signinAppleWithPopup = () => {
  signInWithPopup(auth, appleAuthProvider)
    .then((result) => {
      // The signed-in user info.
      const user = result.user;

      // Apple credential
      const credential = OAuthProvider.credentialFromResult(result);
      if (!credential) {
        return;
      }

      const appleDisplayName = user.displayName ?? "";
      if (appleDisplayName) {
        localStorage.setItem("fullRegName", appleDisplayName);
      }

      //const accessToken = credential.accessToken;
      //const idToken = credential.idToken;
    })
    .catch((error) => {
      // Handle Errors here.
      const errorCode = error.code;
      const errorMessage = error.message;
      // The email of the user's account used.
      const email = error.customData.email;
      // The AuthCredential type that was used.
      const credential = GoogleAuthProvider.credentialFromError(error);
      // ...
    });
};

export const signinGoogleWithPopup = () => {
  signInWithPopup(auth, googleAuthProvider)
    .then((result) => {
      // This gives you a Google Access Token. You can use it to access the Google API.
      const credential = GoogleAuthProvider.credentialFromResult(result);
      if (!credential) {
        return;
      }
      const token = credential.accessToken;
      // The signed-in user info.
      const user = result.user;
      // IdP data available using getAdditionalUserInfo(result)
      // ...

      const googleDisplayName = user.displayName ?? "";
      if (googleDisplayName) {
        localStorage.setItem("fullRegName", googleDisplayName);
      }
    })
    .catch((error) => {
      // Handle Errors here.
      const errorCode = error.code;
      const errorMessage = error.message;
      // The email of the user's account used.
      const email = error.customData.email;
      // The AuthCredential type that was used.
      const credential = GoogleAuthProvider.credentialFromError(error);
      // ...
    });
};

export const signinGoogleWithRedirect = () => {
  signInWithRedirect(auth, googleAuthProvider);
};

export const signOut = () => {
  auth.signOut();
};

export const sendLinkToEmail = (email: string) => {
  fetch(`${serverUrl}/auth/sendSalesLink`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email: email,
      url: window.location.href,
    }),
  })
    .then(() => {
      // The link was successfully sent. Inform the user.
      // Save the email locally so you don't need to ask the user for it again
      // if they open the link on the same device.
      window.localStorage.setItem("emailForSignIn", email);
      // ...
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      // ...
    });
};
